export default function ReplaceModeTip() {
  return (
    <div
      className="mx-4 mb-3 px-3 py-2 rounded-xl flex items-center gap-2"
      style={{ background: "#FEF3C7" }}
    >
      <i className="ri-information-line" style={{ color: "#D97706", fontSize: 15 }} />
      <span className="text-xs text-amber-700">当前为替换模式，选择后将更新AI套餐中的酒店</span>
    </div>
  );
}
